/**
 * Translate a string with arguments
 * @param {string} translation - The string to translate
 * @param {object} args        - The arguments to replace
 * @returns {string}           - The translated string
 */
export const translateWithKeys = (translation, args) => {
  if (translation && args) {
    Object.keys(args).forEach((k) => {
      // eslint-disable-next-line no-param-reassign
      translation = translation.replace(`%${k}%`, args[k]);
    });
  }
  return translation;
};

export default translateWithKeys;
